import classnames from 'classnames'

export type StatusBadgeTone =
  | 'danger'
  | 'dark'
  | 'info'
  | 'neutral'
  | 'success'
  | 'warning'

export interface StatusBadgeProps {
  children: React.ReactNode
  className?: string
  size?: 'small' | 'medium'
  tone?: StatusBadgeTone
}

const toneClassMap: Record<StatusBadgeTone, string> = {
  danger: 'border-rose-200 bg-rose-50 text-rose-700',
  dark: 'border-zinc-900 bg-zinc-900 text-white',
  info: 'border-sky-200 bg-sky-50 text-sky-700',
  neutral: 'border-zinc-200 bg-zinc-100 text-zinc-700',
  success: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  warning: 'border-amber-200 bg-amber-50 text-amber-700'
}

const sizeClassMap = {
  medium: 'px-2.5 py-1 text-xs',
  small: 'px-2 py-0.5 text-[11px]'
} satisfies Record<NonNullable<StatusBadgeProps['size']>, string>

export default function StatusBadge({
  children,
  className,
  size = 'medium',
  tone = 'neutral'
}: StatusBadgeProps) {
  return (
    <span
      className={classnames(
        'inline-flex items-center justify-center rounded-full border font-semibold',
        sizeClassMap[size],
        toneClassMap[tone],
        className
      )}
    >
      {children}
    </span>
  )
}
